import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetRidehailDetailsQueryVariables = Types.Exact<{
  move_id: Types.Scalars['bigint']['input'];
}>;


export type GetRidehailDetailsQuery = { __typename?: 'query_root', moves_by_pk?: { __typename?: 'moves', id: number, parent_move_id?: number | null, pickup_time?: string | null, status?: string | null, driver_status?: string | null, cancel_status?: string | null, cancel_reason?: string | null, consumer_name?: string | null, consumer_phone?: string | null, consumer_pickup?: boolean | null, customer?: { __typename?: 'customers', id: number, name?: string | null } | null, lane?: { __typename?: 'lanes', id: number, description?: string | null, distance_miles?: number | null, pickup: { __typename?: 'locations', id: number, name?: string | null, address?: string | null, latitude?: number | null, longitude?: number | null }, delivery: { __typename?: 'locations', id: number, name?: string | null, address?: string | null, latitude?: number | null, longitude?: number | null } } | null, driver?: { __typename?: 'drivers', id: number, user?: { __typename?: 'users', id: number, display_name: string, avatar_url?: string | null, phone?: string | null } | null } | null, parentMove?: { __typename?: 'moves', id: number, driver_status?: string | null, consumer_name?: string | null, consumer_phone?: string | null, vehicle_vin?: string | null, vehicle_year?: string | null, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_color?: string | null } | null, ridehails: Array<{ __typename?: 'ridehails', id: number, move_id?: number | null, provider?: string | null, status?: string | null, product_type?: string | null, external_id?: string | null, pickup_lat: number, pickup_lng: number, pickup_address?: string | null, dropoff_lat: number, dropoff_lng: number, dropoff_address?: string | null, estimated_price?: number | null, actual_price?: number | null, driver_rating?: number | null, vehicle_year?: number | null, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_color?: string | null, vehicle_license_plate?: string | null, vehicle_photo_url?: string | null, driver_name?: string | null, driver_phone?: string | null, driver_photo_url?: string | null, booked_at?: string | null, driver_assigned_at?: string | null, pickup_at?: string | null, dropoff_at?: string | null }> } | null };


export const GetRidehailDetailsDocument = gql`
    query GetRidehailDetails($move_id: bigint!) {
  moves_by_pk(id: $move_id) {
    id
    parent_move_id
    pickup_time
    status
    driver_status
    cancel_status
    cancel_reason
    consumer_name
    consumer_phone
    consumer_pickup
    customer {
      id
      name
    }
    lane {
      id
      description
      pickup {
        id
        name
        address
        latitude
        longitude
      }
      delivery {
        id
        name
        address
        latitude
        longitude
      }
      distance_miles
    }
    driver {
      id
      user {
        id
        display_name
        avatar_url
        phone
      }
    }
    parentMove {
      id
      driver_status
      consumer_name
      consumer_phone
      vehicle_vin
      vehicle_year
      vehicle_make
      vehicle_model
      vehicle_color
    }
    ridehails(order_by: {created_at: desc}, limit: 1) {
      id
      move_id
      provider
      status
      product_type
      external_id
      pickup_lat
      pickup_lng
      pickup_address
      dropoff_lat
      dropoff_lng
      dropoff_address
      estimated_price
      actual_price
      driver_rating
      vehicle_year
      vehicle_make
      vehicle_model
      vehicle_color
      vehicle_license_plate
      vehicle_photo_url
      driver_name
      driver_phone
      driver_photo_url
      booked_at
      driver_assigned_at
      pickup_at
      dropoff_at
    }
  }
}
    `;

/**
 * __useGetRidehailDetailsQuery__
 *
 * To run a query within a React component, call `useGetRidehailDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRidehailDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRidehailDetailsQuery({
 *   variables: {
 *      move_id: // value for 'move_id'
 *   },
 * });
 */
export function useGetRidehailDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetRidehailDetailsQuery, GetRidehailDetailsQueryVariables> & ({ variables: GetRidehailDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRidehailDetailsQuery, GetRidehailDetailsQueryVariables>(GetRidehailDetailsDocument, options);
      }
export function useGetRidehailDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRidehailDetailsQuery, GetRidehailDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRidehailDetailsQuery, GetRidehailDetailsQueryVariables>(GetRidehailDetailsDocument, options);
        }
// @ts-ignore
export function useGetRidehailDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRidehailDetailsQuery, GetRidehailDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRidehailDetailsQuery, GetRidehailDetailsQueryVariables>;
export function useGetRidehailDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRidehailDetailsQuery, GetRidehailDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetRidehailDetailsQuery | undefined, GetRidehailDetailsQueryVariables>;
export function useGetRidehailDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRidehailDetailsQuery, GetRidehailDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRidehailDetailsQuery, GetRidehailDetailsQueryVariables>(GetRidehailDetailsDocument, options);
        }
export type GetRidehailDetailsQueryHookResult = ReturnType<typeof useGetRidehailDetailsQuery>;
export type GetRidehailDetailsLazyQueryHookResult = ReturnType<typeof useGetRidehailDetailsLazyQuery>;
export type GetRidehailDetailsSuspenseQueryHookResult = ReturnType<typeof useGetRidehailDetailsSuspenseQuery>;
export type GetRidehailDetailsQueryResult = Apollo.QueryResult<GetRidehailDetailsQuery, GetRidehailDetailsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/ridehails/queries/getRidehailDetails.query.gql}
 */
export async function getRidehailDetails(
  variables: GetRidehailDetailsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetRidehailDetailsQuery['moves_by_pk']>
export async function getRidehailDetails(
  variables: GetRidehailDetailsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetRidehailDetailsQuery>
export async function getRidehailDetails(
  variables: GetRidehailDetailsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetRidehailDetailsQuery['moves_by_pk'] | GetRidehailDetailsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetRidehailDetailsQuery>(
    GetRidehailDetailsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.moves_by_pk
}